module.exports = require("./ps-PK.d.ts");